<template>
  <Popup
    :closeAllowed="closeAllowed && !disableCancelButton"
    @close="cancel"
    :onClose="onClose"
  >
    <h1 class="headline5">
      <span>{{ title }}</span>
    </h1>
    <p class="body2 confirm_popup__message">
      <span v-html="message" />
    </p>
    <div v-if="typeToConfirmString" class="body2 type_to_confirm__container">
      <span
        v-if="typeToConfirmInstruction"
        class="type_to_confirm__instructions"
        v-html="typeToConfirmInstruction"
      />
      <TextInput v-model="typeToConfirmInput" :label="typeToConfirmString" />
    </div>
    <div class="confirm_popup__buttons">
      <Button
        v-if="closeAllowed"
        @click.native="cancel"
        :buttonStyle="cancelButtonStyle"
        :disabled="disableCancelButton"
      >
        <span>{{ cancelBtn }}</span>
      </Button>
      <Button
        @click.native="confirm"
        :buttonStyle="confirmButtonStyle"
        :loading="confirmBtnIsLoading"
        :disabled="
          typeToConfirmString
            ? typeToConfirmString !== typeToConfirmInput
            : false
        "
      >
        <EventListener @keyup.enter="confirm" />
        <span>{{ confirmBtn }}</span>
      </Button>
    </div>
  </Popup>
</template>

<script>
import Popup from "./Popup.vue";
import Button from "../atoms/Button.vue";
import EventListener from "../atoms/EventListener.vue";
import TextInput from "../atoms/Inputs/TextInput.vue";

export default {
  name: "ConfirmPopup",
  components: {
    Popup,
    Button,
    EventListener,
    TextInput,
  },
  data() {
    return {
      typeToConfirmInput: "",
    };
  },
  props: {
    popupID: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmBtn: {
      type: String,
      required: true,
    },
    confirmBtnIsLoading: {
      type: Boolean,
      default: false,
    },
    disableCancelButton: {
      type: Boolean,
    },
    cancelBtn: {
      type: String,
      default: "Cancel",
    },
    closeAllowed: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
    },
    cancelButtonStyle: {
      required: false,
      default: "secondary",
    },
    confirmButtonStyle: {
      required: false,
      default: "primary",
    },
    typeToConfirmString: {
      default: null,
    },
    typeToConfirmInstruction: {
      type: String,
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";

.confirm_popup__message {
  width: 400px;
  max-width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
}
.type_to_confirm__container {
  width: 400px;
  margin: 0 0 20px 0;

  .type_to_confirm__instructions {
    display: block;
    margin-bottom: 12px;
  }
}
.confirm_popup__buttons {
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  button {
    margin-left: 16px;
  }
}
</style>
